import styled from '@emotion/styled';
import { space, SpaceProps } from 'styled-system';

export type HeroHeadProps = SpaceProps;

const applyMainStyles = (theme) => ({ ...theme.hero.head });

export const HeroHead = styled.div<HeroHeadProps>(
  ({ theme }) => ({
    ...applyMainStyles(theme),
  }),
  space
);
